"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vTree = exports.dTree = exports.sTree = void 0;
var tree_1 = require("../tree");
var Types_1 = require("../Sentence/Types");
var nodes_1 = require("./nodes");
function nob(s, meta) {
    var img = s.toLowerCase();
    if (typeof meta === "string") {
        img = meta;
        meta = {};
    }
    return { path: s.toLowerCase(), data: s, meta: __assign({ img: img }, meta) };
}
exports.sTree = new tree_1.Tree()
    .AddNodes("/", nob(Types_1.LType[Types_1.LType.Loc]), nob(Types_1.LType[Types_1.LType.Int]), nob(Types_1.LType[Types_1.LType.Autre]))
    .AddNodes("/loc", nob(Types_1.Nombre[Types_1.Nombre.Sin]), nob(Types_1.Nombre[Types_1.Nombre.Plu]))
    .AddNodes("/loc/sin", nodes_1.pronomNodes["je"])
    .AddNodes("/loc/plu", nodes_1.pronomNodes["on"])
    .AddNodes("/int", nob(Types_1.Nombre[Types_1.Nombre.Sin]), nob(Types_1.Nombre[Types_1.Nombre.Plu]))
    .AddNodes("/int/sin", nodes_1.pronomNodes["tu"])
    .AddNodes("/int/plu", nodes_1.pronomNodes["vous"])
    .AddNodes("/autre", nob(Types_1.Nombre[Types_1.Nombre.Sin]), nob(Types_1.Nombre[Types_1.Nombre.Plu]))
    .AddNodes("/autre/sin", nob(Types_1.Genre[Types_1.Genre.Fem]), nob(Types_1.Genre[Types_1.Genre.Masc]))
    .AddNodes("/autre/sin/fem", nodes_1.pronomNodes["elle"])
    .AddNodes("/autre/sin/masc", nodes_1.pronomNodes["il"])
    .AddNodes("/autre/plu", nob(Types_1.Genre[Types_1.Genre.Fem]), nob(Types_1.Genre[Types_1.Genre.Masc]))
    .AddNodes("/autre/plu/fem", nodes_1.pronomNodes["elles"])
    .AddNodes("/autre/plu/masc", nodes_1.pronomNodes["ils"]);
// Noms Fem/Sin
exports.sTree.AddNodes("/autre/sin/fem", "Nom")
    .AddNodes("/autre/sin/fem/nom", nodes_1.nomNodes["voiture"], nodes_1.nomNodes["herbe"]);
// Noms Masc/Sin
exports.sTree.AddNodes("/autre/sin/masc", "Nom")
    .AddNodes("/autre/sin/masc/nom", nodes_1.nomNodes["camion"], nodes_1.nomNodes["animal"]);
// Det Tree Node
exports.dTree = new tree_1.Tree()
    .AddNodes("/", nob(Types_1.DetType[Types_1.DetType.Def]), nob(Types_1.DetType[Types_1.DetType.Ind]), nob(Types_1.DetType[Types_1.DetType.Des]), nob(Types_1.DetType[Types_1.DetType.Pos]), nob(Types_1.DetType[Types_1.DetType.Autre]), nob(Types_1.DetType[Types_1.DetType.Qty]))
    //// Défini
    .AddNodes("/def", nob(Types_1.Nombre[Types_1.Nombre.Sin]), nob(Types_1.Nombre[Types_1.Nombre.Plu]))
    .AddNodes("/def/plu", nodes_1.detNodes["les"])
    .AddNodes("/def/sin", nob(Types_1.Genre[Types_1.Genre.Fem]), nob(Types_1.Genre[Types_1.Genre.Masc]))
    .AddNodes("/def/sin/fem", nodes_1.detNodes["la"], nodes_1.detNodes["l'"])
    .AddNodes("/def/sin/masc", nodes_1.detNodes["le"], nodes_1.detNodes["l'"])
    //// Indéfini
    .AddNodes("/ind", nob(Types_1.Nombre[Types_1.Nombre.Sin]), nob(Types_1.Nombre[Types_1.Nombre.Plu]))
    .AddNodes("/ind/plu", nodes_1.detNodes["des"])
    .AddNodes("/ind/sin", nob(Types_1.Genre[Types_1.Genre.Fem]), nob(Types_1.Genre[Types_1.Genre.Masc]))
    .AddNodes("/ind/sin/fem", nodes_1.detNodes["une"])
    .AddNodes("/ind/sin/masc", nodes_1.detNodes["un"])
    //// Désigné
    .AddNodes("/des", nob(Types_1.Nombre[Types_1.Nombre.Sin]), nob(Types_1.Nombre[Types_1.Nombre.Plu]))
    .AddNodes("/des/plu", nodes_1.detNodes["ces"])
    .AddNodes("/des/sin", nob(Types_1.Genre[Types_1.Genre.Fem]), nob(Types_1.Genre[Types_1.Genre.Masc]))
    .AddNodes("/des/sin/fem", nodes_1.detNodes["cette"])
    .AddNodes("/des/sin/masc", nodes_1.detNodes["ce"], nodes_1.detNodes["cet"]);
// Verbe Tree
exports.vTree = new tree_1.Tree("Verbe");
function AddBranch(tree, node, startPath) {
    if (startPath === void 0) { startPath = "/"; }
    node.forEach(function (value, key) {
        tree.AddNodes(startPath, key);
        var newPath = startPath + (startPath === "/" ? "" : "/") + (tree_1.isChoiceOptions(key) ? key.path : key.toLowerCase());
        if (typeof value === "string" || tree_1.isChoiceOptions(value)) {
            tree.AddNodes(newPath, value);
        }
        else {
            AddBranch(tree, value, newPath);
        }
    });
}
function AddVerbNode(inf, p, se, t, q, c, si) {
    var pt = new Map().set(inf, new Map().set(nob(Types_1.Temps[Types_1.Temps.Present]), new Map()
        .set(nob(Types_1.LType[Types_1.LType.Loc]), new Map().set(nob(Types_1.Nombre[Types_1.Nombre.Sin]), p).set(nob(Types_1.Nombre[Types_1.Nombre.Plu]), q))
        .set(nob(Types_1.LType[Types_1.LType.Int]), new Map().set(nob(Types_1.Nombre[Types_1.Nombre.Sin]), se).set(nob(Types_1.Nombre[Types_1.Nombre.Plu]), c))
        .set(nob(Types_1.LType[Types_1.LType.Autre]), new Map().set(nob(Types_1.Nombre[Types_1.Nombre.Sin]), t).set(nob(Types_1.Nombre[Types_1.Nombre.Plu]), si))));
    AddBranch(exports.vTree, pt);
}
AddVerbNode("manger", "mange", "manges", "mange", "mangeons", "mangez", "mangent");
var tree = new tree_1.Tree();
tree.AddNodes('/', nob("Humain"), nob("Choses"));
// Humain
tree.AddNodes('/humain', nob("Solo", { img: "humain" }), nob("Multi", { img: "multi_humain" }));
tree.AddNodes('/humain/solo', nob("Masculin"), nob("Féminin"));
tree.AddNodes('/humain/multi', nob("Masculin"), nob("Féminin"));
tree.AddNodes('/humain/solo/masculin', nob("Toi", { img: "moi", pronom: "je" }), nob("Interlocuteur", { pronom: "tu" }), nob("Autre", { img: "tier", pronom: "il" }));
tree.AddNodes('/humain/solo/féminin', nob("Toi", { img: "moi", pronom: "je" }), nob("Interlocuteur", { img: "interlocuteur", pronom: "tu" }), nob("Autre", { img: "tier", pronom: "elle" }));
tree.AddNodes('/humain/multi/masculin', nob("Ton groupe", { img: "moi", pronom: "on" }), nob("Interlocuteurs", { img: "interlocuteur", pronom: "vous" }), nob("Autres", { img: "tier" }));
tree.AddNodes('/humain/multi/féminin', nob("Ton groupe", { img: "moi", pronom: "on" }), nob("Interlocuteurs", { img: "interlocuteur", pronom: "vous" }), nob("Autres", { img: "tier", pronom: "elles" }));
tree.AddNodes('/humain/multi/masculin/autres', nob("metiers", { img: null, pronom: "ils", list: ["médecin", "instituteur"] }));
tree.AddNodes('/humain/multi/féminin/autres', nob("metiers", { img: null, pronom: "elles", list: ["médecin", "institutrice"] }));
//Chose
tree.AddNodes('/choses', nob("Solo", { img: "choses" }), nob("Multi", { img: "multi_choses" }));
tree.AddNodes('/choses/solo', nob("Masculin"), nob("Féminin"));
tree.AddNodes('/choses/multi', nob("Masculin"), nob("Féminin"));
tree.AddNodes('/choses/solo/masculin', nob("Toi", { img: "moi", pronom: "je" }), nob("Interlocuteur", { img: "interlocuteur", pronom: "tu" }), nob("Autre", { img: "tier", pronom: "il" }));
tree.AddNodes('/choses/solo/féminin', nob("Toi", { img: "moi", pronom: "je" }), nob("Interlocuteur", { img: "interlocuteur", pronom: "tu" }), nob("Autre", { img: "tier", pronom: "elle" }));
tree.AddNodes('/choses/multi/masculin', nob("Ton groupe", { img: "moi", pronom: "on" }), nob("Interlocuteurs", { img: "interlocuteur", pronom: "vous" }), nob("Autres", { img: "tier", pronom: "ils" }));
tree.AddNodes('/choses/multi/féminin', nob("Ton groupe", { img: "moi", pronom: "on" }), nob("Interlocuteurs", { img: "interlocuteur", pronom: "vous" }), nob("Autres", { img: "tier", pronom: "elles" }));
function updateMeta(node) {
    node.meta.id = node.meta.path;
    node.GetChildren().forEach(function (c) { return updateMeta(c); });
}
var $root = tree.GetNode('/');
updateMeta($root);
exports.default = tree;
